const searchOptions = ['Name', 'Email', 'Phone']

const SearchDropdownItems = searchOptions.map((searchOption) => ({
  value: searchOption,
  label: searchOption,
}))

export default SearchDropdownItems
